import './toggle.style.css'

export interface Props {
  onChange: (value: boolean) => void
  checked: boolean
  name: string
}

export const Toggle = (props: Props) => {
  function handleToggle() {
    props?.onChange(!props.checked)
  }

  return (
    <div className="toggle-box">
      <input id="toggle" name={props.name} className="toggle-checkbox" type="checkbox" />
      <span
        onClick={handleToggle}
        className={props.checked ? 'toggled toggle-switch' : 'toggle-switch'}
      >
        <span className="toggle"></span>
      </span>
      <span className="toggle-box-text">{props.name}</span>
    </div>
  )
}
